// extracted by mini-css-extract-plugin
export default {"tabList":"c8ZXd9XQ0h_landings","tab":"JpEsAHz4Q__landings","s":"vlAuNcg8zx_landings","m":"yWqAjCauLD_landings","l":"rmRmAVtq7z_landings"};